export default __webpack_public_path__ + "static/AwareSuper-78da78d4fc075b8d0b8ad0a749e7d176.png";